import { round, calcTimeZone, getDifferenceByTimeZone } from "../../utils";

const hoursToMs = hrs => hrs * 60 * 60 * 1000;

const getDiffMs = (loadTime = 0, travelTime = 0) =>
  hoursToMs(parseFloat(loadTime) + parseFloat(travelTime));

export const getPickupTime = (requested = new Date(), loadTime, travelTime) => {
  const requestedDateTime = new Date(requested).getTime();
  const diff = getDiffMs(loadTime, travelTime);
  return new Date(requestedDateTime - diff).toISOString();
};

export const getScheduledTime = (pickup = new Date(), loadTime, travelTime) => {
  const pickupDateTime = new Date(pickup).getTime();
  const diff = getDiffMs(loadTime, travelTime);
  return new Date(pickupDateTime + diff).toISOString();
};

export const handleChange = (data, onChange) => e => {
  const value =
    e.target.type === "checkbox" ? e.target.checked : e.target.value;
  let newScheduledDeliveryDateFormatted = data.ScheduledDeliveryDateFormatted;
  let newScheduledDeliveryDate = data.ScheduledDeliveryDate;
  if (e.target.name === "ScheduledDeliveryDate") {
    newScheduledDeliveryDateFormatted = calcTimeZone(
      value,
      data.DeliveryLocation.TimeZone.CodeId
    );
  } else if (e.target.name === "ScheduledDeliveryDateFormatted") {
    const date = new Date(e.target.value);
    const diference = getDifferenceByTimeZone(data, date, "Delivery");
    newScheduledDeliveryDate = date.setHours(date.getHours() - diference);
  }
  onChange({
    ...data,
    [e.target.name]: value,
    ScheduledDeliveryDateFormatted: newScheduledDeliveryDateFormatted,
    ScheduledDeliveryDate: newScheduledDeliveryDate
  });
};

export const handleOrderedOnByChange = (data, onChange) => e => {
  const updates = { ...data };
  updates[e.target.name] =
    e.target.type === "checkbox" ? e.target.checked : e.target.value;

  if (e.target.checked) {
    updates.OrderDateTime = new Date();
  }

  onChange({ ...updates });
};

export const handleTimeChange = (data, onChange) => e => {
  if (e.target.value.length > 4) return;
  const d = { ...data, [e.target.name]: e.target.value };

  if (e.target.value.length !== 0) {
    d.PickupDate = getPickupTime(
      d.RequestedDeliveryDate,
      d.EstimatedLoad,
      d.EstimatedTravel
    );

    d.ScheduledDeliveryDate = getScheduledTime(
      d.PickupDate,
      d.EstimatedLoad,
      d.EstimatedTravel
    );
  }
  onChange(d);
};

export const handlePickupDateChange = (data, onChange) => e => {
  const d = { ...data, [e.target.name]: e.target.value };
  d.ScheduledDeliveryDate = getScheduledTime(
    d.PickupDate,
    d.EstimatedLoad,
    d.EstimatedTravel
  );
  d.ScheduledDeliveryDateFormatted = calcTimeZone(
    d.ScheduledDeliveryDate,
    d.DeliveryLocation.TimeZone.CodeId
  );
  d.PickupDateFormatted = calcTimeZone(
    d.PickupDate,
    d.PickupLocation.TimeZone.CodeId
  );
  onChange(d);
};

export const handlePickupDateFormattedChange = (data, onChange) => e => {
  const d = { ...data, [e.target.name]: e.target.value };
  const date = new Date(e.target.value);
  const diference = getDifferenceByTimeZone(data, date, "Pickup");
  d.PickupDate = date.setHours(date.getHours() - diference);
  d.ScheduledDeliveryDate = getScheduledTime(
    d.PickupDate,
    d.EstimatedLoad,
    d.EstimatedTravel
  );
  d.ScheduledDeliveryDateFormatted = calcTimeZone(
    d.ScheduledDeliveryDate,
    d.DeliveryLocation.TimeZone.CodeId
  );

  onChange(d);
};

export const handleRequestedDeliveryDateChange = (
  data,
  onChange = () => {}
) => e => {
  const d = { ...data, [e.target.name]: e.target.value };
  d.ScheduledDeliveryDate = e.target.value;

  d.RequestedDeliveryDateFormatted = calcTimeZone(
    d.RequestedDeliveryDate,
    d.DeliveryLocation.TimeZone.CodeId
  );
  d.PickupDate = getPickupTime(
    d.RequestedDeliveryDate,
    d.EstimatedLoad,
    d.EstimatedTravel
  );
  d.PickupDateFormatted = calcTimeZone(
    d.PickupDate,
    d.PickupLocation.TimeZone.CodeId
  );
  d.ScheduledDeliveryDateFormatted = calcTimeZone(
    d.ScheduledDeliveryDate,
    data.DeliveryLocation.TimeZone.CodeId
  );

  onChange(d);
};

export const handleRequestedDeliveryDateFormattedChange = (
  data,
  onChange = () => {}
) => e => {
  const d = { ...data, [e.target.name]: e.target.value };
  const date = new Date(e.target.value);

  const diference = getDifferenceByTimeZone(data, date, "Delivery");
  const newDate = date.setHours(date.getHours() - diference);

  d.ScheduledDeliveryDate = newDate;

  d.RequestedDeliveryDate = newDate;

  d.PickupDate = getPickupTime(
    d.RequestedDeliveryDate,
    d.EstimatedLoad,
    d.EstimatedTravel
  );
  d.PickupDateFormatted = calcTimeZone(
    d.PickupDate,
    d.PickupLocation.TimeZone.CodeId
  );
  d.ScheduledDeliveryDateFormatted = calcTimeZone(
    d.ScheduledDeliveryDate,
    data.DeliveryLocation.TimeZone.CodeId
  );

  onChange(d);
};

export const handleRoundTime = (data, onChange) => e => {
  if (e.target.value.length) {
    const value = round(e.target.value, 0.5);
    handleTimeChange(
      data,
      onChange
    )({
      target: { name: e.target.name, value }
    });
  }
};

export const calculateOrderDates = data => {
  const date = new Date(data.PickupDate);
  const diference = getDifferenceByTimeZone({ ...data.Route }, date, "Pickup");
  const PickupDate = new Date(
    date.setHours(date.getHours() - diference)
  ).toISOString();
  const ScheduledDeliveryDate = getScheduledTime(
    PickupDate,
    data.EstimatedLoad,
    data.EstimatedTravel
  );
  return {
    PickupDate,
    ScheduledDeliveryDate
  };
};
